export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-es-ES.1fa64087.xlsx";